<section class="use-cases" id="use-cases">
  <div class="use-cases__grid"></div>
  <div class="blob blob-1"></div>

  <div class="container">
    <div class="use-cases__header">
      <span class="section-tag">{{ t().uc_tag }}</span>
      <h2 class="section-title">{{ t().uc_title }}<br><span>{{ t().uc_subtitle }}</span></h2>
    </div>

    <div class="use-cases__grid">
      <div class="uc-card" *ngFor="let uc of cases()">
        <div class="uc-card__visual" [style.--zone-color]="uc.color">
          <svg viewBox="0 0 200 120" class="zone-svg">
            <!-- Area background -->
            <rect x="10" y="10" width="180" height="100" rx="8" fill="rgba(0,102,204,0.05)" stroke="rgba(0,102,204,0.15)" stroke-width="1"/>
            <!-- Detection zones -->
            <rect x="20" y="20" width="160" height="80" rx="4" class="zone-rect" fill="rgba(0,102,204,0.03)" stroke="currentColor" stroke-width="1" stroke-dasharray="4 3"/>
            <!-- People representation -->
            <circle cx="50" cy="55" r="8" fill="rgba(255,255,255,0.15)" class="person-icon"/>
            <circle cx="80" cy="50" r="8" fill="rgba(255,255,255,0.15)" class="person-icon"/>
            <circle cx="110" cy="60" r="8" fill="rgba(255,255,255,0.15)" class="person-icon"/>
            <!-- Detection box overlay -->
            <rect x="42" y="47" width="16" height="16" stroke="#22c55e" stroke-width="2" fill="none" class="detect-box"/>
            <rect x="72" y="42" width="16" height="16" stroke="#f59e0b" stroke-width="2" fill="none" class="detect-box" style="animation-delay: 0.5s"/>
            <!-- Scan line -->
            <line x1="20" y1="60" x2="180" y2="60" stroke="#0066cc" stroke-width="0.5" class="scan-line" opacity="0.4"/>
            <!-- Label -->
            <rect x="38" y="65" width="24" height="12" rx="2" fill="rgba(34,197,94,0.2)"/>
            <text x="50" y="74" fill="#22c55e" font-size="6" text-anchor="middle" font-weight="bold">AI</text>
          </svg>
        </div>

        <div class="uc-card__content">
          <h3>{{ uc.title }}</h3>
          <p>{{ uc.desc }}</p>

          <div class="uc-card__tags">
            <span class="uc-tag" *ngFor="let feat of uc.feats">{{ feat }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>